import {
  CLEAR_ERRORS,
  FETCH_USER_INFO_REQUEST,
  RECEIVE_DEVELOPER_KEY_ERRORS
} from '../constants/action-types'

const nullErrors = { developerKeyError: null }

export default (state = nullErrors, action) => {
  switch (action.type) {
    case CLEAR_ERRORS: {
      return nullErrors
    }
    case FETCH_USER_INFO_REQUEST: {
      return nullErrors
    }
    case RECEIVE_DEVELOPER_KEY_ERRORS: {
      const { error } = action
      return Object.assign({}, state, {
        developerKeyError: error
      })
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/errors-reducer.js